import React, { Component } from 'react';
import { Link, withRouter, useHistory } from 'react-router-dom';
import ReactDOMServer from 'react-dom/server';
import L from 'leaflet'

import _ from 'underscore';

import helpers from '../helpers.js';

function MapPopup(props) {
	const history = useHistory();

	const getUrl = () => {
		let newSearchParams = helpers.updateSearchParams(props.history.location.search, {
			stadsetning: props.item.id
		});

		return '#'+props.history.location.pathname+newSearchParams;
	}

	return <div>
		<h4>{props.item.nafn}</h4>
		<a href={getUrl()}>Nánar</a>
	</div>
}

class MapView extends Component {
	constructor(props) {
		super(props);

		this.mapContainer = React.createRef();
		this.icelandCenter = [64.963051, -19.020836];

		this.state = {
		};
	}

	componentDidMount() {
		this.layerLmiKort = L.tileLayer.wms('https://gis.lmi.is/mapcache/web-mercator?', {
			layers: 'LMI_Kort',
			format: 'image/png',
			attribution: 'Landmælingar Íslands',
			//crs: 'EPSG:4326',
			transparent: 'true'
		});

		this.layerEsriWorldImagery = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
			attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
		});

		this.layerEsriOcean = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Ocean_Basemap/MapServer/tile/{z}/{y}/{x}', {
			attribution: 'Tiles &copy; Esri &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri',
			maxZoom: 13
		});

		this.layerOpenStreetMap = L.tileLayer('https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
			maxZoom: 19,
			attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>'
		});

		let baseLayers = {
			'Open Street Map': this.layerOpenStreetMap,
			'LMÍ grunnkort': this.layerLmiKort,
		};

		this.map = L.map(this.mapContainer.current, {
			minZoom: 2,
			maxZoom: 16,
			layers: [this.layerEsriWorldImagery]
		}).setView([60, 0], 3);

		this.markersLayer = L.layerGroup().addTo(this.map);
	}

	componentDidUpdate(prevProps) {
		if (this.props.selectedBird && (!prevProps.selectedBird || this.props.selectedBird.name != prevProps.selectedBird.name)) {
			this.setSelectedBird(this.props.selectedBird);
		}
	}

	setSelectedBird(bird) {
		fetch('data/'+bird.name+'.geojson')
			.then(res => res.json())
			.then(json => {
				if (this.birdLayer) {
					this.map.removeLayer(this.birdLayer);
				}

				json.features.forEach((item, i) => {
					console.log(item.properties)
					item.properties.vetur = item.properties.vetur ? item.properties.vetur.split(',').map(i => parseFloat(i)) : [];
					item.properties.sumar = item.properties.sumar ? item.properties.sumar.split(',').map(i => parseFloat(i)) : [];
					item.properties.varp = item.properties.varp ? item.properties.varp.split(',').map(i => parseFloat(i)) : [];
					item.properties.varp_adal = item.properties.varp_adal ? item.properties.varp_adal.split(',').map(i => parseFloat(i)) : [];

				});

				let winterData = _.uniq(_.flatten(json.features.map(feature => feature.properties.vetur)));
				let summerData = _.uniq(_.flatten(json.features.map(feature => feature.properties.sumar)));
				let nestingData = _.uniq(_.flatten(json.features.map(feature => feature.properties.varp)));
				let nestingMainData = _.uniq(_.flatten(json.features.map(feature => feature.properties.varp_adal)));

				this.birdLayer = L.geoJSON(json, {
					style: function(d) {
						let winterArea = _.intersection(d.properties.vetur, winterData).length > 0;

						return {
							//color: winterArea ? '#3ca9e9' : '#ffd400',
							color: winterArea ? '#e73b00' : '#ffd400',
							weight: 1,
							fillOpacity: 0.6
						}
					}
				});

				if (this.props.onData) {
					this.props.onData({
						winterData: winterData,
						summerData: summerData,
						nestingData: nestingData,
						nestingMainData: nestingMainData
					});
				}

				this.birdLayer.addTo(this.map);

				this.map.fitBounds(this.birdLayer.getBounds());
			})
	}

	updateMapSize() {
		this.map.invalidateSize();
	}

	render() {
		return (
			<div className={'map-wrapper '+(this.props.className || '')}>
				<div ref={this.mapContainer} className="map-container" />
			</div>
		);
	}
}

export default withRouter(MapView);
